module.exports = __webpack_public_path__ + "static/media/ic-heart.179170d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-heart.svg
// module id = 629
// module chunks = 14